'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsubscribedDesktopSearchUserNav = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _SellPageLinks = require('../NavItems/SellPageLinks');

var _LoginLink = require('../NavItems/LoginLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_AFTER_MOUSELEAVE_TIME = 750;

var UnsubscribedDesktopSearchUserNav = exports.UnsubscribedDesktopSearchUserNav = function (_Component) {
  (0, _inherits3.default)(UnsubscribedDesktopSearchUserNav, _Component);

  function UnsubscribedDesktopSearchUserNav() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, UnsubscribedDesktopSearchUserNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = UnsubscribedDesktopSearchUserNav.__proto__ || (0, _getPrototypeOf2.default)(UnsubscribedDesktopSearchUserNav)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = { dropdownOpen: false }, _this2.handleMouseLeave = function () {
      return _this.timer = setTimeout(_this.toggleDropdown, CLOSE_AFTER_MOUSELEAVE_TIME);
    }, _this2.handleMouseEnter = function () {
      var dropdownOpen = _this.state.dropdownOpen;


      clearTimeout(_this.timer);

      if (!dropdownOpen) {
        _this.toggleDropdown();
      }
    }, _this2.toggleDropdown = function () {
      return _this.setState(function (state) {
        return {
          dropdownOpen: !state.dropdownOpen
        };
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(UnsubscribedDesktopSearchUserNav, [{
    key: 'render',
    value: function render() {
      var isLoggedIn = this.props.isLoggedIn;
      var dropdownOpen = this.state.dropdownOpen;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'li',
          {
            className: 'header__dropdown',
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
          },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('header__dropdown__target', {
                'header__dropdown__target--open': dropdownOpen
              })
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              tagName: 'strong',
              id: 'nav.more',
              defaultMessage: 'More'
            }),
            _react2.default.createElement(_reactInlinesvg2.default, { className: 'header__dropdown__arrow svg ml-', uniquifyIDs: false, src: require('../../../../static/img/arrow.svg') })
          ),
          dropdownOpen && _react2.default.createElement(
            'div',
            { className: 'header__dropdown__panel' },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(_SellPageLinks.SellPageLinks, null)
            )
          )
        ),
        !isLoggedIn && _react2.default.createElement(_LoginLink.LoginLink, null)
      );
    }
  }]);
  return UnsubscribedDesktopSearchUserNav;
}(_react.Component);

UnsubscribedDesktopSearchUserNav.propTypes = {
  isLoggedIn: _propTypes2.default.bool
};